__webpack_require__.p = "https://certificate.quantstamp.com/full/strata-update-to-tranches/79a657c4-717f-4ce0-8fbc-20cfcfe97bd1/";